/**
 * Brand color palette — matches the Dashboard's C object.
 * Import these constants in any component that uses inline styles.
 * For Tailwind components the equivalents are listed in comments.
 */
export const C = {
  teal:        "#0F766E",  // teal-700
  tealDark:    "#0D5F58",  // teal-800
  tealLight:   "#14B8A6",  // teal-400
  bg:          "#F9FAFB",  // gray-50
  white:       "#FFFFFF",
  text:        "#111827",  // gray-900
  textMid:     "#374151",  // gray-700
  textSoft:    "#9CA3AF",  // gray-400
  border:      "#E5E7EB",  // gray-200
  borderLight: "#F3F4F6",  // gray-100
  accent:      "#F59E0B",  // amber-500
  accentSoft:  "#FEF3C7",  // amber-100
  purple:      "#7C3AED",  // violet-600
  shadow:      "0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(15,118,110,0.08)",
  shadowHover: "0 4px 12px rgba(0,0,0,0.06), 0 12px 32px rgba(15,118,110,0.14)",
  red:         "#EF4444",  // red-500
  green:       "#10B981",  // emerald-500
  blue:        "#3B82F6",  // blue-500
};

/** Chart bar color sequence */
export const CHART_COLORS = [
  "#0F766E", "#14B8A6", "#F59E0B", "#7C3AED", "#3B82F6", "#EC4899", "#EF4444", "#10B981",
];

export default C;
